import { NoStyleButton, type NoStyleButtonProps } from "@aviary/components/Button";

import * as styles from "./DotButton.styles";

interface Props extends NoStyleButtonProps {
  isSelected?: boolean;
}

const DotButton = ({ isSelected, ...rest }: Props) => {
  const dotButtonStyles = [styles.dotButton.base, isSelected && styles.dotButton.selected];

  return <NoStyleButton css={dotButtonStyles} {...rest} />;
};

DotButton.displayName = "DotNavigation.Button";

export { DotButton };
